import axios from 'axios';
import {
  BASE_URL,
  PRODUCT_SEARCH_SERVICE,
  PRODUCT_SEARCH_SERVICE_ENDPOINT
} from './configuration';
import store from '../store';

export const PRODUCT_SEARCH_SERVICE_URL = `${BASE_URL}/${PRODUCT_SEARCH_SERVICE}`;

export const getBuyerProducts = (categoryId, groupByFilter, size) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_LOADER',
      payload: true
    });

    const params = {
      category: categoryId
    };

    if (groupByFilter) {
      params.groupBy = groupByFilter;
    }

    if (size) {
      params.size = size;
    }

    return axios
      .get(
        `${PRODUCT_SEARCH_SERVICE_URL}/${PRODUCT_SEARCH_SERVICE_ENDPOINT.GET_PRODUCTS}?`,
        {
          headers: {
            'Content-Type': 'application/json',
            'X-tenant':
              store.getState().UserServiceReducer?.csmTenants?.tenantId ??
              process.env.REACT_APP_SELLER_TENANT_ID
          },
          params
        }
      )
      .then((response) => {
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
        dispatch({
          type: 'GET_BUYER_PRODUCTS',
          payload: response?.data?.products
        });
        return response?.data;
      })
      .catch((error) => {
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
        dispatch({
          type: 'ERROR',
          error: error.response
        });
      });
  };
};
